import { Component, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Subscription } from 'rxjs'

import { LABEL_KEYS, UserAnswer } from '../../../../data/models'
import { QuestionViewService } from '../question-view.service'
import { QuestionTypeView } from '../question-type-view'
import { QuestionCorrectnessService } from '../../../../core/services'

@Component({
  selector: 'mp-numeric-entry-question-view',
  templateUrl: './numeric-entry-question-view.html',
  styleUrls: ['./numeric-entry-question-view.scss']
})
export class NumericEntryQuestionViewComponent extends QuestionTypeView implements OnDestroy, OnChanges {

  public reviewMode: boolean = false
  public correct: boolean = false

  public constructor(
    _questionViewService: QuestionViewService,
    private _questionCorrectnessService: QuestionCorrectnessService
  ) { super(_questionViewService) }

  public get labelBefore() {
    return this._answerChoiceGroup.getLabel(LABEL_KEYS.NUMERIC_ENTRY_BEFORE)
  }

  public get labelAfter() {
    return this._answerChoiceGroup.getLabel(LABEL_KEYS.NUMERIC_ENTRY_AFTER)
  }

  public get topChoice() {
    return this._answerChoiceGroup.answerChoices[0]
  }

  public get bottomChoice() {
    return this._answerChoiceGroup.answerChoices[1]
  }

  public get topPrompt() {
    return this._answerChoiceGroupForm.getPrompt('topPrompt')
  }

  public get bottomPrompt() {
    return this._answerChoiceGroupForm.getPrompt('bottomPrompt')
  }

  public get topFormControl() {
    return this._answerChoiceGroupFormGroup.get(this.topPrompt.key)
  }

  public get bottomFormControl() {
    return this._answerChoiceGroupFormGroup.get(this.bottomPrompt.key)
  }

  private get _answerChoiceGroup() {
    return this.question.firstAnswerChoiceGroup
  }

  private get _answerChoiceGroupFormGroup() {
    return this.firstAnswerChoiceFormGroup
  }

  private get _answerChoiceGroupForm() {
    return this.answerChoiceGroupPrompt.forms[0]
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.question) {
      this._removeAnswerSubscriptions()
    }
    const userAnswers = this._createCorrectnessUserAnswers()
    this.correct = this._questionCorrectnessService.isCorrect(this.question, userAnswers)
    this.reviewMode = this._questionViewService.reviewMode
    this._setAnswerTriggers()
  }

  public ngOnDestroy() {
    this._removeAnswerSubscriptions()
  }

  private _removeAnswerSubscriptions() {
    this._subscriptions.forEach((subscription) => subscription.unsubscribe())
  }

  private _subscriptions: Subscription[] = []

  private _setAnswerTriggers() {
    const topObservable = this._wrapAnswerPromptObservable(this.topFormControl.valueChanges)
    const bottomObservable = this._wrapAnswerPromptObservable(this.bottomFormControl.valueChanges)
    this._addAnswerSubscription(topObservable)
    this._addAnswerSubscription(bottomObservable)
  }

  private _wrapAnswerPromptObservable(valueObservable: Observable<any>): Observable<any> {
    const pauseTime = 750
    return valueObservable
      .debounce(() => Observable.timer(pauseTime))
      .distinctUntilChanged()
  }

  private _addAnswerSubscription(answerInputObservable: Observable<any>) {
    const subscription = answerInputObservable.subscribe(() => {
        const questionAnswers = [
          { value: this.topFormControl.value, choiceId: this.topChoice.id }
        ]
        if (this.bottomChoice.value) {
          questionAnswers.push({ value: this.bottomFormControl.value, choiceId: this.bottomChoice.id })
        }
        this._questionViewService.questionAnswered.emit(questionAnswers)
    })
    this._subscriptions.push(subscription)
  }

  private _createCorrectnessUserAnswers(): UserAnswer[] {
    return this._answerChoiceGroup.answerChoices.map((answerChoice, index) => {
      const userAnswer = new UserAnswer()
      userAnswer.answerChoice = answerChoice
      userAnswer.value = this._answerChoiceGroupForm.prompts[index].value
      return userAnswer
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/numeric-entry-question-view/numeric-entry-question-view.component.ts